import type { StoryboardSegment } from '../../types'
import { buildStatusChipProps } from './statusUtils'
import { cn } from '@/lib/utils'

interface SegmentStatusChipProps {
  segment: StoryboardSegment;
}

const SegmentStatusChip: React.FC<SegmentStatusChipProps> = ({ segment }) => {
  const statusChip = buildStatusChipProps(segment);
  const colorClass =
    statusChip.color === 'success'
      ? 'bg-emerald-500/90 text-white'
      : statusChip.color === 'error'
        ? 'bg-red-500/90 text-white'
        : statusChip.color === 'warning'
          ? 'bg-amber-500/90 text-white'
          : statusChip.color === 'info'
            ? 'bg-sky-500/90 text-white'
            : 'bg-muted text-foreground'
  const outlinedClass =
    statusChip.color === 'success'
      ? 'text-emerald-600 border border-emerald-500/40'
      : statusChip.color === 'error'
        ? 'text-red-600 border border-red-500/40'
        : statusChip.color === 'warning'
          ? 'text-amber-700 border border-amber-500/40'
          : statusChip.color === 'info'
            ? 'text-sky-700 border border-sky-500/40'
            : 'text-foreground border border-border'
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium',
        statusChip.variant === 'filled' ? colorClass : outlinedClass
      )}
    >
      {statusChip.label}
    </span>
  )
};

export default SegmentStatusChip;
